module.exports = __webpack_public_path__ + "static/media/origin-protocol.bd55eb6a.svg";